import { useCreateCouponCode } from '@streamster/shared/api/api.admin';
import Heading from '#/components/Heading/Heading';
import { useAppNavigation } from '@streamster/shared/navigation/navigation.ref';
import CouponForm from '#/screens/adminCouponCodes/CouponForm/CouponForm';
import { useToasterContext } from '@streamster/shared/toaster/toaster.provider';

export const AddNewCouponCode: React.FC = () => {
  const { mutateAsync: createCouponCode } = useCreateCouponCode();
  const navigation = useAppNavigation();
  const toaster = useToasterContext();

  const handleSubmit = async (payload: any) => {
    const response = await createCouponCode(payload);
    toaster.success({
      title: 'Coupon code created successfully',
      message: `Coupon ${response.data.code} created`,
    });
    navigation.navigate('AdminCouponCodes', { type: payload.type });
  };

  return (
    <>
      <Heading variant="page">Add New Coupon Code</Heading>
      <CouponForm
        onSubmit={handleSubmit}
        submitLabel="Add Coupon Code"
        onCancel={() => navigation.navigate('AdminCouponCodes')}
      />
    </>
  );
};

export default AddNewCouponCode;
